import React from 'react'
import { NavLink, Outlet } from 'react-router'
import { useLocale } from '@betina/ui'

const navItems = [
  { to: '/', label: 'dashboard', icon: '🏠' },
  { to: '/promos', label: 'promos', icon: '🏷️' },
  { to: '/planner', label: 'planner', icon: '📅' },
  { to: '/stock', label: 'stock', icon: '🧊' },
  { to: '/shopping', label: 'shopping', icon: '🛒' },
  { to: '/household', label: 'household', icon: '👨‍👩‍👧' },
  { to: '/history', label: 'history', icon: '📋' },
]

export function Layout() {
  const { t, locale, setLocale } = useLocale()

  return (
    <div className="min-h-screen flex flex-col max-w-lg mx-auto bg-white shadow-xl relative">
      {/* Header */}
      <header className="bg-emerald-600 text-white px-4 py-3 flex items-center justify-between sticky top-0 z-10">
        <div className="flex items-center gap-2">
          <span className="text-2xl">🥘</span>
          <span className="font-bold text-lg">Betina</span>
        </div>
        <button
          onClick={() => setLocale(locale === 'fr' ? 'en' : 'fr')}
          className="text-sm text-emerald-100 hover:text-white px-2 py-1 rounded"
        >
          {locale === 'fr' ? '🇬🇧 EN' : '🇫🇷 FR'}
        </button>
      </header>

      {/* Page content */}
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>

      {/* Bottom nav */}
      <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-lg bg-white border-t border-gray-200 safe-pb z-10">
        <div className="flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center py-2 text-xs transition-colors ${
                  isActive ? 'text-emerald-600' : 'text-gray-400 hover:text-gray-600'
                }`
              }
            >
              <span className="text-lg leading-tight">{item.icon}</span>
              <span className="mt-0.5 truncate">{t(item.label)}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  )
}
